// Initialize angular modules.

angular.module('dpw.filters', []);
angular.module('dpw.services', ['dpw.filters']);
angular.module('dpw.directives', ['dpw.services']);
angular.module('dpw.components', ['dpw.services']);
angular.module('dpw.common', [
    'tmh.dynamicLocale',
    'ngRoute',
    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'dpw.directives',
    'dpw.services',
    'dpw.filters',
    'dpw.components',
    'ngFileUpload',
    'dndLists'
]);